import * as NOTIFICATION from '../actionTypes/notification';
import * as RESET from '../actionTypes/reset';

const initState = {
  sendItineraryCount: 0,
  sharedCollectionsFolderCount: 0,
  sharedTripCount: 0,
  msgs: [],
  skip: 0,
  totalCount: 0,
};
const copyState = JSON.parse(JSON.stringify(initState));

export default (state = copyState, action) => {
  switch (action.type) {
    case NOTIFICATION.FETCH_NOTIFICATION_LIST.LOADING:
      return {
        ...state,
      };
    case NOTIFICATION.FETCH_NOTIFICATION_LIST.SUCCESS:
      return {
        ...state,
        msgs: action.payload.msgs || [],
        skip: action.payload.skip || 0,
        totalCount: action.payload.totalCount || 0,
      };
    case NOTIFICATION.FETCH_NOTIFICATION_LIST.FAIL:
      return {
        ...state,
      };

    case NOTIFICATION.GET_NOTIFICATION_COUNT.LOADING:
      return {
        ...state,
      };

    case NOTIFICATION.GET_NOTIFICATION_COUNT.SUCCESS:
      return {
        ...state,
        sendItineraryCount: action.payload.sendItineraryCount || 0,
        sharedCollectionsFolderCount:
          action.payload.sharedCollectionsFolderCount || 0,
        sharedTripCount: action.payload.sharedTripCount || 0,
      };

    case NOTIFICATION.GET_NOTIFICATION_COUNT.FAIL:
      return {
        ...state,
      };

    case RESET.RESET_PAGE.NOTIFICATION:
      return initState;
    default:
      return state;
  }
};
